import {AiFillFacebook, AiOutlineTwitter, AiFillLinkedin} from 'react-icons/ai';

import Footer from '@jobseeker/feature-navigation/widgets/Footer';
import useInterceptor from '@jobseeker/common-core/hooks/useInterceptor';
import {shallowEqual, useSelector} from 'react-redux';
import {useEffect, useState} from 'react';
import {loadIimjobsCategoriesTabs} from '@jobseeker/common-core/utils/categories';
import type {AppState} from '@jobseeker/common-core/types';
import { getPublicAssetUrl } from '@jobseeker/common-core/utils';

const FooterHarness = () => {
  const interceptor: any = useInterceptor();

  const page = useSelector((state: AppState) => state.app.page, shallowEqual);

  const jobLoading = useSelector(
    (state: AppState) => state.job.loadMoreEnabled
  );

  const socialLinks = [
    {
      icon: <AiFillFacebook />,
      url: 'https://www.facebook.com/iimjobs',
      label: 'Facebook',
    },
    {
      icon: <AiFillLinkedin />,
      url: 'https://www.linkedin.com/company/iimjobs.com',
      label: 'LinkedIn',
      // isButton: true,
    },
    {
      icon: <AiOutlineTwitter />,
      url: 'https://twitter.com/iimjobs',
      label: 'Twitter',
    },
  ];
  const {
    footer: {
      logoUrl,
      columnLinks,
      otherLinks,
      bottomLinks,
      headerLabel,
      bgcolor,
    },
    header: {
      meta: {tabsList},
    },
  } = interceptor;

  const isAppIimjobs = process.env.NEXT_PUBLIC_APP_NAME === 'iimjobs';

  const [transTabsList, setTransTabsList] = useState<any[]>(tabsList || []);

  useEffect(() => {
    if (!isAppIimjobs) return;
    (async () => {
      try {
        const transformed = await loadIimjobsCategoriesTabs();
        if (Array.isArray(transformed) && transformed.length > 0) {
          setTransTabsList(transformed);
        }
      } catch {
        // silent fallback
      }
    })();
  }, [isAppIimjobs]);

  return (
    <Footer
      logoUrl={getPublicAssetUrl(logoUrl)}
      page={page}
      tabsList={transTabsList}
      socialLinks={socialLinks}
      columnLinks={columnLinks}
      otherLinks={otherLinks}
      bottomLinks={bottomLinks}
      headerLabel={headerLabel}
      bgcolor={bgcolor}
      jobLoading={!!jobLoading}
    />
  );
};

export default FooterHarness;
